import { styled } from '@mui/material/styles'
import { Fab, Box, Typography } from '@mui/material'
import BackspaceIcon from '@mui/icons-material/Backspace'

export const CallDrawerDialerStyles = styled(Box)({
  padding: '0 12px',
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: '0.625rem',
})

export const CallDrawerFabStyles = styled(Fab)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: 'none',
  backgroundColor: theme.legacyColors.ELLIPSE_BG,
  margin: '2.5%',

  '& .empty': {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.background.default,
  },
}))

export const CallDrawerBackspaceIconStyles = styled(BackspaceIcon)(
  ({ theme }) => ({
    color: theme.palette.text.secondary,
  }),
)

export const CallDrawerDialerNumberStyles = styled(Typography)(({ theme }) => ({
  fontSize: '2.2em',
  padding: '0 4px',
  color: theme.palette.text.secondary,
}))
